import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ isUser, children }) => {
  if (!isUser) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;
